import * as React from 'react';

const X = ({
  fill = '#4A4F4A',
  width = '24',
  height = '24'
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 19.6862C0 9.19275 8.50659 0.686157 19 0.686157V0.686157C29.4934 0.686157 38 9.19275 38 19.6862V19.6862C38 30.1796 29.4934 38.6862 19 38.6862V38.6862C8.50659 38.6862 0 30.1796 0 19.6862V19.6862Z" fill="#616161" />
    <path d="M12.8943 14.04L17.5862 21.3075L12.9937 26.96H14.0112L18.0355 22.0035L21.2355 26.96H25.0799L20.178 19.3678L24.5037 14.04H23.4893L19.728 18.6699L16.7387 14.04L12.8943 14.04ZM14.1093 14.72H16.4018L23.8649 26.28H21.5724L14.1093 14.72Z" fill="white" />
  </svg>
);

export default X;
